import { render } from "./CardBody.vue?vue&type=template&id=38be7427&scoped=true&ts=true"
import script from "./CardBody.vue?vue&type=script&lang=ts"
export * from "./CardBody.vue?vue&type=script&lang=ts"

import "./CardBody.vue?vue&type=style&index=0&id=38be7427&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38be7427"]])

export default __exports__